import React from "react";
import { ExpandedArticleContainer } from "../../../../components/container-article";

export default function ExpandedArticle({data, similar_articles}) {
  return (
    <>
        <ExpandedArticleContainer article={data} similar_articles={similar_articles}/>
    </>
  );  
}